import { http } from '@martech-solution/utils/utils';

const controller = 'hr/compensation-types';

export const getCompensationTypesDropdown = async () => {
  return await http.get(`${controller}/dropdown`);
};
